import React from 'react';

import { ActionIcon, useMantineTheme } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';

interface IBackButtonProps {
  handleOnClick?: (data: any) => void;
  label?: string;
}

const BackButton = ({ handleOnClick = () => {}, label = 'Back' }: IBackButtonProps): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <ActionIcon
      size='lg'
      radius='md'
      variant='light'
      onClick={handleOnClick}
      aria-label={label}
      title={label}
    >
      <IconChevronLeft color={theme.black} />
    </ActionIcon>
  );
};

export default BackButton;
